<template>
    <box :hideable="true">
        <template v-slot:header>
            <h4>
                {{resource('IOFormat_Index_SubHeading_Create')}}
            </h4>
        </template>

        <template v-slot:body>
            <div class="single-column-grid">

                <base-format class="grid-container"
                    ref="formatBase"
                    :type="type" 
                    
                    :name.sync="model.name"
                    :isExport.sync="model.isExport"
                    :isImport.sync="model.isImport"
                    @valid="baseValid = $event"
                >
                    <label>{{resource('IOFormatListViewModel_Type_DisplayName')}}</label>
                    <v-select class="form-control"
                        v-model="type"
                        :options="types"

                        :disabled="types.length === 0"
                        :clearable="false"
                    >
                        <div slot="no-options" />
                    </v-select>

                </base-format>
  
                <entity-format v-if="isEntity" class="grid-container" v-model="attributes" @valid="entityValid = $event"/>
 
                <csv-format v-if="isCsv" class="grid-container" :file.sync="model.csvFile" :separator.sync="model.separator" @valid="csvValid = $event"/>

                <div class="grid-right">
                    <button class="btn btn-primary" @click="createFormat" :disabled="!valid">
                        {{resource('IOFormat_Index_Submit_Create_Button')}}
                    </button>
                </div>

            </div>
        </template>
    </box>    
</template>

<script>

import types,{formatType} from '../Util/formatTypes';

import VSelect from 'vue-select';
import Box from '../../../Components/Util/BootstrapBox.vue';

import BaseFormat from './Formats/Base.vue';
import EntityFormat from './Formats/Entity/Entity.vue';
import CsvFormat from './Formats/Csv.vue';

import formatTypes from '../Util/formatTypes';
import api from '../api';
import resources from '../../../Util/Mixins/resources';
import { bootstrapSuccessGrowl, bootstrapDangerGrowl } from '../../../Util/growler';

export default {
    name: 'create',
    mixins: [resources],
    components: {
        Box,
        BaseFormat,
        EntityFormat,
        CsvFormat,
        VSelect
    },
    methods: {
        createFormat() {
            const vm = this;

            const clearForm = () => {
                this.model = {
                    name: null,
                    csvFile: null,
                    separator: ';',
                    isImport: false,
                    isExport: false
                };

                this.attributes = [];
                this.type = types[0]
            };

            const submit = (format) => {
                vm.$emit('format-created', format);
                bootstrapSuccessGrowl("IO Format created.");
                
                clearForm();
                this.$refs.formatBase.resetValidation();
            };

            api.createIoFormat(this.model).then((format) => {
                if(vm.attributes.length > 0 ) {
                    api.createIoItems(format.id, vm.attributes).then(
                        submit(format),
                        bootstrapDangerGrowl);
                } else {
                    submit(format);
                }
            }, bootstrapDangerGrowl);
        }
    },
    computed: {
        types() {
            return types;
        },
        isEntity() {
            return this.type.id === formatType.entity;
        },
        isCsv() {
            return this.type.id === formatType.csv;
        },
        valid() {
            return this.baseValid && (!this.isEntity || this.entityValid) && (!this.isCsv || this.csvValid);
        }
    },
    watch: {
        type(value) {
            if(value.id !== formatType.csv) {
                this.model.csvFile = null;
                this.model.separator = null;
            } 
            if(value.id !== formatType.entity) {
                this.attributes = [];
            }
        }
    },
    data() {
        return {
            type: types[0],
            model: {
                csvFile: null,
                separator: ';',
                isImport: false,
                isExport: false
            },
            attributes: [],
            baseValid: false,
            entityValid: false,
            csvValid: false
        }
    }
};
</script>

<style lang="scss" scoped src="../Style/create.scss">

</style>